import { CarouselItemValue } from 'generated/mos/org/getty/audio'
import { Media } from 'generated/mos/media'
import { TranslatableLinkableStringValue, TranslatableStringValue, TranslatableMediaValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'

import {
  createTranslatableLinkableStringValue,
  createTranslatableStringValue,
  getTranslatableValue,
  setTranslatableValue,
  createTranslatableMediaValue,
  getTranslatableLinkableValue,
  setTranslatableLinkableValue,
} from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length)) {
    return false
  }

  return value
}

export const audioCarouselItemValueSchema: Schema<CarouselItemValue.AudioItem.Entity> = {
  audio: {
    read: (value, language) => value ? getTranslatableValue(value, language) : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableMediaValue(value as any, language),
      existingValue ?
        existingValue as TranslatableMediaValue.Entity :
        TranslatableMediaValue.defaults,
    ) as any as TranslatableMediaValue.Entity : undefined,
  }
}

export const imageCarouselItemValueSchema: Schema<CarouselItemValue.ImageItem.Entity> = {
  carouselImageRef: {
    read: value => value,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  fullScreenImageRef: {
    read: value => value,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  altText: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
      existingValue ?
      existingValue as TranslatableStringValue.Entity :
      TranslatableStringValue.defaults
    ) as any as TranslatableStringValue.Entity : undefined,
  },
  creditText: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
      existingValue as TranslatableLinkableStringValue.Entity :
      TranslatableLinkableStringValue.defaults
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  publicImageTitle: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
      existingValue ?
      existingValue as TranslatableStringValue.Entity :
      TranslatableStringValue.defaults
    ) as any as TranslatableStringValue.Entity : undefined,
  },
}

export const videoCarouselItemValueSchema: Schema<CarouselItemValue.VideoItem.Entity> ={
  video: {
    read: (value, language) => getTranslatableValue(value, language) as any as Media.Ref | undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableMediaValue(value as any, language),
      existingValue ?
        existingValue as TranslatableMediaValue.Entity :
        TranslatableMediaValue.defaults,
    ) as any as TranslatableMediaValue.Entity : undefined,
  },
}
